













import { Component, Vue } from 'vue-property-decorator';
import user from '@/store/modules/user';
import {PortfolioCompany} from '@/store/models';
import PortfolioCompanyItem from '@/views/PortfolioCompanyItem.vue';
@Component({
    components: {PortfolioCompanyItem},
})
export default class Portfolio extends Vue {
    async gotoCompany(OrgNr: string) {
        await user.clearCompany();
        this.$router.push({ name: 'overview', params: { OrgNr } });
    }

    get companies(): PortfolioCompany[] | null {
        if (!user.companies) { return []; }

        const filter = user.companyFilter;
        return user.companies.filter((c: PortfolioCompany, index: number, array: PortfolioCompany[]) => {
            if (!filter) { return true; }
            if (c.OrgNr.includes(filter)) { return true; }
            if (c.Name.toLowerCase().includes(filter)) { return true; }
            return false;
        }).slice(0, 50);
    }

    get allCompanies(): PortfolioCompany[] | null {
        const companies = user.companies;
        if (companies === null) {
            return null;
        }
        return companies.sort( (a: PortfolioCompany, b: PortfolioCompany) => a.Name.localeCompare(b.Name));
    }
}
